import React, { useState } from "react";
import icon1 from "../../../assets/images/dw20/icon.svg";
import iconWhite from "../../../assets/images/dw20/icon-white.svg";
import DWModal from "./DWModal";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  staticBounceVariants
} from "shared/components/animations";
const DWSlideCard = ({
  currentPlayerCard,
  handleSetModalCard,
  isCzarPlayer = false,
  playedCard,
  screens
}) => {
  const isSingleCardPlayed = _.size(playedCard) === 1;
  const response_card_text = _.get(screens, "response_card_text ");
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`slide-cards ${
        isCzarPlayer && isSingleCardPlayed ? "single-card" : ""
      }`}
    >
      {isCzarPlayer ? (
        playedCard?.map((item, index) => (
          <motion.div
            variants={staticBounceVariants}
            className="card"
            key={index}
          >
            <h2 className="title">Done with 2020</h2>
            <div className="icon-right">
              <img src={icon1} className="img-fluid" alt="" />
            </div>
          </motion.div>
        ))
      ) : (
        <>
          {currentPlayerCard?.cards?.map((item, index) => (
            <motion.div
              variants={staticBounceVariants}
              className="card"
              key={index}
              onClick={() => handleSetModalCard && handleSetModalCard(item)}
            >
              <p className="long-text">{item?.text}</p>
              <p className="hash-left">#DoneWith2020</p>
            </motion.div>
          ))}
        </>
      )}
    </motion.div>
  );
};

export default DWSlideCard;
